// extracted by mini-css-extract-plugin
module.exports = {"container":"similarNFTs_container__3AriP","wrapper":"similarNFTs_wrapper__3UaoC"};